import React, { useState, useEffect, useContext, useRef } from 'react'
import {
  Layout,
  Card,
  Table,
  Button,
  Input,
  Divider,
  Row,
  Col,
  message,
  Form,
  Select,
  Spin,
  DatePicker,
  AutoComplete,
  Switch,
  TimePicker
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import { ArrowLeftOutlined, ShoppingCartOutlined } from '@ant-design/icons'
import { InputGroup } from 'reactstrap'
import TextArea from 'antd/lib/input/TextArea'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import {
  getDecryptID,
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  verifyPkgFeature
} from '../../../appRedux/actions/GlobalMethods'
import { INVENTORY_SCREEN } from '../../../constants/Pages'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import ProductSearch from '../../../components/ProductSearch'
import {
  StringIsNullOrEmpty,
  loadSearchSelectedProduct
} from '../../../appRedux/actions'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const bgcolor = '#e5eaed'
const { Footer } = Layout
const dateFormat = 'DD MMM YYYY'
const timeFormat = 'h:mm A'
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24
      //offset: 0,
    },
    sm: {
      span: 16
      //offset: 0,
    },
    md: {
      span: 24
      //  offset: 0,
    }
  }
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}
const dateConfig = {
  rules: [
    {
      type: 'object',
      required: true,
      message: <IntlMessages id='products.inventorycount.pleaseenterdate' />
    }
  ]
}
const timeConfig = {
  rules: [
    {
      type: 'object',
      required: true,
      message: (
        <IntlMessages id='products.inventoryCount.starttimevalidationmessage' />
      )
    }
  ]
}

const InventoryCountCreate = ({ match }) => {
  const mode = match.params.mode
  const inventoryTakeID = match.params.id
  const isAddMode = !parseInt(inventoryTakeID)

  const history = useHistory()
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  //#region useState
  const [getLoader, setLoader] = React.useState(isAddMode ? false : true)
  const [isRegistering, SetisRegistering] = React.useState(false)
  const [selected, setselected] = useState([])
  const [getIsPartialCount, setIsPartialCount] = useState(true)
  const [options, setOptions] = useState([])
  const [getSearchProd, setSearchProd] = useState([])
  const [getoutletData, setOutletData] = useState([])
  const [getOutletName, setOutletName] = useState('All Outlets')
  const [getShortCurr, setShortCurr] = useState('')
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [getIsCountNameChange, setIsCountNameChange] = useState(false)
  const [getShowInActive, setShowInActive] = useState(true)
  const [getStartDate, setStartDate] = useState(moment().format(dateFormat))
  const [getStartTime, setStartTime] = useState(moment().format(timeFormat))
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)

  //#endregion useState

  //#region useSelector
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getSearchSelectedProduct = useSelector(
    ({ Products }) => Products.searchSelectedProduct
  )
  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  )
  //#endregion useSelector

  //#region useEffect

  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      const commonData = getReduxCommonSetting

      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}

      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
        setShortCurr(currencyData.currencyCode)
        setCurrData(currencyData)
      }

      // rights && permissions

      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)

        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)

          setAccessLoading(false)
        } else {
          toInitialState()

          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (
        getSearchSelectedProduct &&
        getSearchSelectedProduct.productName != undefined
      ) {
        let outletID = form.getFieldValue('Outlet')
        if (outletID != '' && outletID != undefined) {
          onSelect(getSearchSelectedProduct)
        } else {
          message.error('Please Select Outlet')
        }
      }
    }
    return () => (mounted = false)
  }, [getSearchSelectedProduct])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }

    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }

    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }

    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }

    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }

    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }
  function toInitialState () {
    setRights([])

    setPermissions([])

    setIsAllowRead(false)

    setIsDisableCreate(true)

    setIsDisableUpdate(true)

    setIsDisableDelete(true)

    setAccessLoading(true)
  }

  useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!verifyPkgFeature(PkgFeatures.InventoryManagement)) {
        setIsFeatureAllowed(false)
      }
      dispatch(setCommonConfigs(INVENTORY_SCREEN))

      if (!isAddMode) {
        let body = {
          BehaviorName: 1,
          InventoryTakeID: inventoryTakeID
        }
        getInventoryDataByID(body, PkgFeatures.InventoryManagement)
      }
    }

    return () => (mounted = false)
  }, [])

  //#endregion useEffect

  //#region Api Services
  async function postInvenotyCountService (body, pkgFeature) {
    const behaviorType = isAddMode ? BEHAVIOUR_TYPE.POST : BEHAVIOUR_TYPE.UPDATE
    await ds
      .postInventoryCountData(body, behaviorType, pkgFeature ? pkgFeature : '')
      .then(res => {
        SetisRegistering(false)
        if (res.data.data.isSaveUdate) {
          if (body.IsStartCount) {
            let inventorTakeID = res.data.data.inventoryTakeID
            history.push(
              `/Dashboard/inventory/inventorycount/${inventorTakeID}/perform`
            )
          } else {
            message.success('Inventory Count Successfully Saved')
            history.push('/Dashboard/inventory/inventorycount/listing')
          }
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        SetisRegistering(false)
        // message.error("Something went wrong...");
      })
  }

  async function getInventoryDataByID (body, featureID) {
    setLoader(true)
    const getInventoryData = ds.getInventoryDataByID(
      body,
      BEHAVIOUR_TYPE.GET,
      featureID
    )
    await getInventoryData
      .then(response => {
        if (response) {
          if (response.statusName == 'In Progress') {
            history.push(
              `/Dashboard/inventory/inventorycount/${inventoryTakeID}/perform`
            )
          } else {
            let startDateTimeObj = moment(response.executedOn)
            form.setFieldsValue({
              StartDate: startDateTimeObj,
              StartTime: startDateTimeObj,
              Outlet: getDecryptID(response.outletID),
              CountName: response.inventoryName
            })

            let isPartialCount =
              response.countType.toLowerCase().trim() == 'partial'
                ? true
                : false
            setIsPartialCount(isPartialCount)
            setShowInActive(response.showInActive)
            let products =
              response.inventoryEditProduct &&
              response.inventoryEditProduct.map(e => {
                return {
                  key: e.productID,
                  name: e.productName
                }
              })
            setselected(products)
            setLoader(false)
          }
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setLoader(false)
        if (error.response && error.response.status === 401) {
          notAllowMsgCheck(error)
          setTimeout(() => {
            dispatch(userLogOut('store.getState()'))
          }, 3000)
        } else {
          notAllowMsgCheck(error)
        }
      })
  }
  //#endregion Api Services

  //#region Calculated  Function Start
  const CountNameBuilder = (type, param) => {
    if (!getIsCountNameChange && isAddMode) {
      let countDate = moment(moment(), 'DD/MM/YYYY').format('Do MMM YYYY') //form.getFieldsValue("StartDate") ;
      let countStartTime = moment(moment()).format('hh:mm A') // form.getFieldsValue("StartTime");
      let countOutletName = getOutletName
      if (param != null) {
        if (type == 'Date') {
          countDate = moment(param, 'DD/MM/YYYY').format('Do MMM YYYY')
        }
        if (type == 'Time') {
          countStartTime = moment(param).format('hh:mm A')
        }
        if (type == 'Outlet') {
          countOutletName = param
        }
        let finalCountName =
          countOutletName + '-' + countDate + ', ' + countStartTime
        form.setFieldsValue({ CountName: finalCountName })
      }
    }
  }
  //#endregion Calculated  Function Start

  //#region Change Functions, OnClick Form Save
  const onFinishFailed = errorInfo => {
    message.error('Kindly provide missing fields')
  }

  const onFormFinish = async isStartCount => {
    form
      .validateFields()
      .then(values => {
        SetisRegistering(true)
        let value = values
        let inventoryName = value.CountName
        let outletID = value.Outlet
        let inventoryProducts =
          selected &&
          selected.map(e => {
            return {
              ProductID: e.key
            }
          })
        let executeOn = moment(
          value['StartDate'].format('DD/MM/YYYY') +
            ' ' +
            value['StartTime'].format('hh:mm a'),
          'DD/MM/YYYY hh:mm a'
        ).format()
        let counType = getIsPartialCount ? 1 : 2 //1. Partial Count ,  2. FULL Count//Idhar agr koi product select na ho or partial select kia hwa ho tw isko ham full krdenge jb product send krenge.

        if (inventoryName == '') {
          message.error('Please enter inventory name')
          return false
        }
        if (outletID == '') {
          message.error('Please Select outlet')
          return false
        }
        if (inventoryProducts.length == 0) {
          counType = 2
        }

        const PostInventoryDataObj = {
          BehaviorName: isAddMode ? 1 : 3, // Add : Edit
          InventoryTakeID: isAddMode ? '0' : inventoryTakeID,
          InventoryName: inventoryName,
          OutletID: outletID.toString(),
          CountType: counType,
          ShowInActive: getShowInActive,
          InventoryTakeStatusID: '', //Backend pr calculate krenge ye status
          ExecutedOn: executeOn,
          InventoryProducts: inventoryProducts,
          IsStartCount: isStartCount
        }

        postInvenotyCountService(
          PostInventoryDataObj,
          PkgFeatures.InventoryManagement
        )
      })
      .catch(errorInfo => {
        message.error('Kindly provide missing fields')
      })
  }

  const handleChangeShowInActive = checked => {
    setShowInActive(checked)
  }

  const onSelect = async selectedObj => {
    let newProd = []
    let productID = ''
    let outletID = form.getFieldValue('Outlet')

    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID = selectedObj.productID
      }
    } else {
      productID = ''
    }
    if (outletID != '' && outletID != undefined) {
      if (!StringIsNullOrEmpty(productID)) {
        await ds
          .getBookSearchProd(
            `?keys=""&outletid=${outletID}&isstock=${false}&isInventory=${true}&isActiveProduct=${getShowInActive}&isPB=${false}&isVariantProduct=${true}&productID=${productID}`
          )
          .then(response => {
            const productData = response.data
            if (productData.msgCode == 'GENERAL_SUCCESS') {
              if (productData && productData.data.length > 0) {
                newProd = productData.data.map(e => {
                  return {
                    key: e.productID,
                    name: e.productName
                  }
                })
              } else {
                message.warning(
                  `Can't add this product,because it is non track inventory product`
                )
              }
            }
            if (productData.msgCode == 'GENERAL_ERROR') {
              message.error(productData.msgDescription)
            }
          })
          .catch(e => console.log('Product Search Issue', e))

        if (newProd.length > 0) {
          if (
            selected.length > 0 &&
            !selected.some(e => getDecryptID(e.key) === getDecryptID(productID))
          ) {
            setselected(selected.concat(newProd))
          } else if (selected.length == 0) {
            setselected(newProd)
          } else {
            message.error('Duplicate products are not allowed')
          }
          dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
        } else {
          message.warning(
            `Can't add this product,because it is non track inventory product`
          )
        }
      }
    } else {
      message.error('Please Select Outlet')
    }
  }

  // const onSelect = (value, option) => {
  //   let selectedOption =
  //     getSearchProd.filter((item) => item.productID == option.key).length > 0
  //       ? getSearchProd
  //           .filter((item) => item.productID == option.key)
  //           .map((e, seq) => {
  //             return {
  //               key: e.productID,
  //               name: e.productName,
  //             };
  //           })
  //       : [];
  //   if (selected.length > 0 && !selected.some((e) => e.key === option.key)) {
  //     setselected(selected.concat(selectedOption));
  //   } else if (selected.length == 0) setselected(selectedOption);
  // };
  function removeTableProd (e) {
    let data = selected.filter(a => a.key != e.key)
    setselected(data)
    if (data.length == 0) {
    }
  }
  function handleChangeOutlet (e) {
    let name =
      getReduxStoreOutlets?.filter(a => getDecryptID(a.id) == e)[0]?.outlet ||
      null
    setOutletName(name)
    CountNameBuilder('Outlet', name)
  }
  //#endregion Change Functions, OnClick Form Save

  //#region Table Columns
  var columns = [
    {
      title: 'Product',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '',
      dataIndex: 'remove',
      key: 'remove',
      render: (text, record) => (
        <a
          className='trash-icon-btn'
          onClick={() => removeTableProd(record)}
          style={{ fontSize: 'large' }}
        >
          <i className='icon icon-trash' />
        </a>
      )
    }
  ]
  //#endregion Table Columns

  return (
    <>
      {getIsAllowRead && isFeatureAllowed ? (
        <div>
          {getLoader ? (
            <Skeleton count={12} height={30} />
          ) : (
            <>
              <div className='Content-wrapper AddInventoryCount-pg'>
                <Spin
                  tip={<IntlMessages id='sell.cashlisting.cashloading' />}
                  spinning={isRegistering}
                  size='large'
                >
                  <div className='back-arrow-h1'>
                    <h1 className='d-flex align-items-center'>
                      <ArrowLeftOutlined
                        className='dk-vertical-align'
                        onClick={() =>
                          history.push(
                            '/Dashboard/inventory/inventorycount/listing'
                          )
                        }
                      />
                      <span className='mx-2'>
                        {' '}
                        {mode === 'edit' ? (
                          <IntlMessages id='products.inventoryCount.addinventorycount' />
                        ) : (
                          <IntlMessages id='products.inventoryCount.addinventorycount' />
                        )}
                      </span>
                    </h1>
                  </div>

                  <Row className='ant-row dk-row-bg-color m-0 Sec-heading-bg'>
                    <Col xl={16} lg={16} md={12} sm={24} xs={24}>
                      <p className='title vd-hero-intro custom-font-color-black m-0'>
                        <IntlMessages id='products.inventoryCount.scheduleafullor' />
                      </p>
                    </Col>

                    <Col xl={8} lg={8} md={12} sm={24} xs={24}>
                      <div className='pg-header-btn'>
                        <Button
                          className=''
                          type='primary'
                          htmlType='submit'
                          size='large'
                          onClick={() => {
                            onFormFinish(false)
                          }}
                        >
                          <IntlMessages id='products.inventoryCount.saveexit' />
                        </Button>
                        <Button
                          className=''
                          htmlType='submit'
                          type='primary'
                          size='large'
                          onClick={() => {
                            onFormFinish(true)
                          }}
                          disabled={
                            isAddMode ? getIsDisableCreate : getIsDisableUpdate
                          }
                        >
                          <IntlMessages id='products.inventoryCount.startcount' />
                        </Button>
                      </div>
                    </Col>
                  </Row>

                  <div className='custom-mg-top-25'>
                    <Row className='General-div'>
                      <Col lg={6} md={24} sm={24} xs={24}>
                        <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                          <IntlMessages id='products.inventoryCount.general' />
                        </h2>
                        <p className='dk-font-size-15'>
                          <IntlMessages id='products.inventoryCount.generaldesc' />
                        </p>
                      </Col>

                      <Col
                        lg={18}
                        md={24}
                        sm={24}
                        xs={24}
                        className='p-0-add-form'
                      >
                        <Form
                          {...formItemLayout}
                          form={form}
                          name='InventoryCountForm'
                          onFinish={onFormFinish}
                          onFinishFailed={onFinishFailed}
                          scrollToFirstError
                          initialValues={{
                            StartDate: moment(),
                            StartTime: moment()
                          }}
                        >
                          <InputGroup size='large' className='md-col-100'>
                            <Form.Item
                              className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                              name='StartDate'
                              label={
                                <IntlMessages id='products.inventoryCount.startdate' />
                              }
                              {...dateConfig}
                            >
                              <DatePicker
                                className='w-100'
                                size='large'
                                //  defaultValue={moment(getStartDate, dateFormat)}
                                format={dateFormat}
                                onChange={e => CountNameBuilder('Date', e)}
                                inputReadOnly={true}
                              />
                            </Form.Item>

                            <Form.Item
                              className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                              name='StartTime'
                              label={
                                <IntlMessages id='products.inventoryCount.starttime' />
                              }
                              {...timeConfig}
                            >
                              <TimePicker
                                format={timeFormat}
                                size='large'
                                use12Hours
                                className='w-100'
                                onChange={e => CountNameBuilder('Time', e)}
                              />
                            </Form.Item>
                          </InputGroup>

                          <InputGroup size='large' className='md-col-100'>
                            <Form.Item
                              className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                              name='Outlet'
                              label={
                                <IntlMessages id='products.inventoryCount.outlet' />
                              }
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <IntlMessages id='products.inventoryCount.pleaseselectanoutlet' />
                                  )
                                }
                              ]}
                            >
                              <Select
                                onChange={handleChangeOutlet}
                                size='large'
                                disabled={!isAddMode}
                                showSearch
                                optionFilterProp='children'
                                placeholder='Select outlet'
                              >
                                {getReduxStoreOutlets &&
                                  getReduxStoreOutlets.length > 0 &&
                                  getReduxStoreOutlets.map((e, key) => {
                                    return (
                                      <Select.Option
                                        key={key}
                                        value={getDecryptID(e.id)}
                                      >
                                        {e.outlet}
                                      </Select.Option>
                                    )
                                  })}
                              </Select>
                            </Form.Item>

                            <Form.Item
                              className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                              name='CountName'
                              label={
                                <IntlMessages id='products.inventoryCount.countname' />
                              }
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <IntlMessages id='products.inventorycount.pleaseenternameofthiscount' />
                                  )
                                }
                              ]}
                            >
                              <Input
                                size='large'
                                placeholder='Count Name'
                                onChange={() => {
                                  setIsCountNameChange(true)
                                }}
                              />
                            </Form.Item>
                          </InputGroup>
                        </Form>
                      </Col>
                    </Row>

                    <Divider className='mt-3 mb-4' />

                    <Row>
                      <Col lg={6} md={24} sm={24} xs={24}>
                        <div>
                          <h2 className='custom-font-weight-500 custom-font-color-black'>
                            <IntlMessages id='products.inventoryCount.chooseproduct' />
                          </h2>
                          <p className='dk-font-size-15'>
                            <IntlMessages id='products.inventoryCount.chooseproductdesc' />
                          </p>
                        </div>
                      </Col>

                      <Col lg={18} md={24} sm={24} xs={24}>
                        <Row className='dk-flex-promo'>
                          <Col
                            lg={12}
                            md={12}
                            sm={12}
                            xs={24}
                            className='dk-flex-promo-1'
                          >
                            <div className='dk-custom-promoadd-card1 dk-flex-promo-1'>
                              <Card
                                className={`${
                                  getIsPartialCount
                                    ? 'ant-card-bordered-active'
                                    : ''
                                }`}
                                onClick={() => {
                                  setIsPartialCount(true)
                                }}
                              >
                                <h3>
                                  <IntlMessages id='products.inventoryCount.partialcount' />
                                </h3>

                                <Divider className='mt-3 mb-4' />

                                <p className='mb-0'>
                                  <IntlMessages id='products.inventoryCount.partialcountdesc' />
                                </p>
                                <p className='custom-addpromo-hidetext'>a</p>
                              </Card>
                            </div>
                          </Col>
                          <Col
                            lg={12}
                            md={12}
                            sm={12}
                            xs={24}
                            className='dk-flex-promo-1'
                          >
                            <div className='dk-custom-promoadd-card1 dk-flex-promo-1'>
                              <Card
                                className={`${
                                  !getIsPartialCount
                                    ? 'ant-card-bordered-active'
                                    : ''
                                }`}
                                onClick={() => {
                                  setIsPartialCount(false)
                                }}
                              >
                                <h3>
                                  <IntlMessages id='products.inventoryCount.fullcount' />
                                </h3>

                                <Divider className='mt-3 mb-4' />

                                <p className='mb-0'>
                                  <IntlMessages id='products.inventoryCount.fullcountdesc' />
                                </p>
                                <p className='custom-addpromo-hidetext'>a</p>
                              </Card>
                            </div>
                          </Col>
                        </Row>

                        {getIsPartialCount ? (
                          <>
                            <Divider className='mt-3 mb-4' />

                            <Form.Item
                              name='ShowInActive'
                              className='dk-inv-count-switch'
                            >
                              <Switch
                                defaultChecked={getShowInActive}
                                onChange={handleChangeShowInActive}
                              >
                                <IntlMessages id='products.inventorycount.includeinactiveproducts' />
                              </Switch>
                            </Form.Item>

                            <p>
                              {selected.length}

                              <span>
                                {' '}
                                <IntlMessages id='products.inventoryCount.productswillbecounted' />
                              </span>
                            </p>

                            <Row className='pro-search-bar mb-3'>
                              <Col lg={24} md={24} sm={24} xs={24}>
                                <ProductSearch isLabel={false} />
                              </Col>
                            </Row>

                            {selected.length > 0 ? (
                              <Table
                                className='gx-table-responsive'
                                dataSource={selected}
                                columns={columns}
                              />
                            ) : (
                              ''
                            )}
                          </>
                        ) : (
                          ''
                        )}
                      </Col>
                    </Row>
                  </div>
                </Spin>
              </div>
            </>
          )}
        </div>
      ) : (
        <NotAllowedComponent
          getAccessLoading={getAccessLoading}
          textType={!isFeatureAllowed ? 2 : 1}
        />
      )}
    </>
  )
}

export default InventoryCountCreate
